<div class="objective-form-header" [ngModelGroup]="groupName">
    <div class="title-input">
        <span>{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_FORM_TITLE_SHORT__' | translate}}:</span>
        <div class="title-form-group">
            <input
                name="title"
                #titleRef="ngModel"
                [ngModel]="title"
                (ngModelChange)="onTitleChange($event)"
                [required]="true"
                [disabled]="disabled"
                [placeholder]="placeholder || ''">
            <div *ngIf="titleRef.invalid && (titleRef.dirty || titleRef.touched)" class="invalid-feedback">
                <div *ngIf="titleRef.errors?.['required']">{{'__REVIEW_REPORT_FORM_VALIDATE_REQUIRED__' | translate}}</div>
            </div>
        </div>
    </div>
    <ion-radio-group name="duration" [ngModel]="duration" (ngModelChange)="onDurationChange($event)">
        <div class="objective-form-radio">
            <ion-radio value="short" [disabled]="disabled" ></ion-radio>
            <div class="label">
                <div class="title">{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_SHORT_TERM_GOAL__' | translate}}</div>
                <div class="text">{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_SHORT_TERM_GOAL_PERIOD__' | translate}}</div>
            </div>
        </div>
        <div class="objective-form-radio">
            <ion-radio value="medium" [disabled]="disabled" ></ion-radio>
            <div class="label">
                <div class="title">{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_MEDIUM_TERM_GOAL__' | translate}}</div>
                <div class="text">{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_MEDIUM_TERM_GOAL_PERIOD__' | translate}}</div>
            </div>
        </div>
        <div class="objective-form-radio">
            <ion-radio value="long" [disabled]="disabled" ></ion-radio>
            <div class="label">
                <div class="title">{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_LONG_TERM_GOAL__' | translate}}</div>
                <div class="text">{{'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_LONG_TERM_GOAL_PERIOD__' | translate}}</div>
            </div>
        </div>
    </ion-radio-group>
</div>
<ng-content></ng-content>
